<template>
  <SiteHydrationSafeLink
          :to="`/${locale}`"
          class="block max-w-[200px] w-full relative z-20 transition-transform duration-100 header-sticky__logo">
    <img alt="Enerwin logo" class="w-full h-auto" height="755" loading="eager" src="/img/logo-enerwin-horizontal.png"
         width="1943"/>
  </SiteHydrationSafeLink>
</template>
<script lang="ts" setup>
const {locale} = useI18n();
</script>
